<template>
  <div class="py-2">
    <label v-if="label" class="block text-sm font-medium text-gray-700">{{label}}</label>
    <div v-if="description" class="text-gray-500 text-xs">
      {{description}}
    </div>
    <fieldset class="mt-1 ">    
        <div class="flex gap-1 flex-wrap">
            <div v-for="item in data" :key="item.name" class="cursor-pointer relative  p-1 rounded-sm" >              
                <div class="absolute top-0 w-8 h-8 rounded-sm " @click="update(item.value)"></div>
                <div class="" >
                    <input :id="item.value" type="radio" :checked="item.value === checked" :class="(item.value == value) ? [item.ring,'ring-4 ring-offset-1 rounded-sm'] : ' ' " />                    
                    <span @click="update(item.value)" aria-hidden="true" :class="[item.value, 'h-[20px] w-[20px] border border-black border-opacity-10 rounded-sm absolute top-[8px] left-[2px]']"></span>
                </div>
            </div>
        </div>
    </fieldset>
  </div>
</template>

<script>


export default {
  name: 'RadioList',
  props: {
    label: String,
    description: String,    
    value: String,
  },

  data() {
    return {
       checked: '',
       data: [
        {
          value: 'bg-slate-900',
          ring: 'ring-slate-900 ',
        },
        {
          value: 'bg-slate-50',
          ring: 'ring-slate-50 ',
        },                       
        {
          value: 'bg-slate-500',
          ring: 'ring-slate-500 ',
        },         

        {
          value: 'bg-stone-500',
          ring: 'ring-stone-500 ',
        },         
        
        {
          value: 'bg-red-500',
          ring: 'ring-red-500 ',
        },
        {
          value: 'bg-rose-500',
          ring: 'ring-rose-500',
        },
        {
          value: 'bg-pink-500',
          ring: 'ring-pink-500',
        },
        {
          value: 'bg-fuchsia-500',
          ring: 'ring-fuchsia-500',
        },
        {
          value: 'bg-purple-500',
          ring: 'ring-purple-500',
        },
        {
          value: 'bg-violet-500',
          ring: 'ring-violet-500',
        },
        {
          value: 'bg-indigo-500',
          ring: 'ring-indigo-500',
        },
        {
          value: 'bg-indigo-800',
          ring: 'ring-indigo-800',
        },        
        {
          value: 'bg-blue-700',
          ring: 'ring-blue-700',
        },        
        {
          value: 'bg-blue-500',
          ring: 'ring-blue-500',
        },
        {
          value: 'bg-sky-500',
          ring: 'ring-sky-500',
        },
        {
          value: 'bg-cyan-800',
          ring: 'ring-cyan-800',
        },        
        {
          value: 'bg-cyan-500',
          ring: 'ring-cyan-500',
        },
        {
          value: 'bg-teal-500',
          ring: 'ring-teal-500',
        },   
        {
          value: 'bg-emerald-500',
          ring: 'ring-emerald-500',
        },
        {
          value: 'bg-green-500',
          ring: 'ring-green-500',
        },
        {
          value: 'bg-green-800',
          ring: 'ring-green-800',
        },
        {
          value: 'bg-lime-700',
          ring: 'ring-lime-700',
        },            
        {
          value: 'bg-lime-500',
          ring: 'ring-lime-500',
        },                          
        {
          value: 'bg-yellow-300',
          ring: 'ring-yellow-300',
        },        
        {
          value: 'bg-yellow-500',
          ring: 'ring-yellow-500',
        },  
        {
          value: 'bg-amber-500',
          ring: 'ring-amber-500',
        },                         
        {
          value: 'bg-orange-500',
          ring: 'ring-orange-500',
        },
        {
          value: 'bg-orange-700',
          ring: 'ring-orange-700',
        },        
               
                
       ],
    }    
  },
  methods: {
    update(value){
      this.checked = value;
      this.$emit('update:modelValue', value);
    }
  },
  created() {
    if(this.value){
      this.update(this.value);      
    }
    else {
      this.update(this.data[6].value);
    }
  },
}
</script>
